import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { MemberService } from '../../../core/members/member.service';
import { SettingsService } from '../../../core/settings/settings.service';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { filter, map } from 'rxjs/operators';
import { TopNavbarComponent } from '@app/shared/components/top-navbar/top-navbar.component';
import { TranslatePipe } from '@ngx-translate/core';
import { LoyaltyClubHeaderComponent } from '@app/shared/components/loyalty-club-header/loyalty-club-header.component';
import { AsyncPipe } from '@angular/common';
import { LoyaltyClubFooterComponent } from '@app/shared/components/loyalty-club-footer/loyalty-club-footer.component';
import { PROFILE_DESTROY_FINISH_PATH } from '@app/+profile-form/profile-routes';
import { Observable } from 'rxjs';
import { MemberInterface } from '@app/core/_models/member-interface';

@Component({
  selector: 'app-delete-profile',
  templateUrl: './delete-profile.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    TopNavbarComponent,
    RouterLink,
    TranslatePipe,
    LoyaltyClubHeaderComponent,
    AsyncPipe,
    LoyaltyClubFooterComponent,
  ],
})
export class DeleteProfileComponent {
  private router = inject(Router);
  private route = inject(ActivatedRoute);
  private settingsService = inject(SettingsService);
  private memberService = inject(MemberService);

  protected settings = this.settingsService.settings;
  protected memberIdentifier$ = this.getMemberIdentifier();

  protected submit(): void {
    this.memberService.destroy()
      .subscribe(() => this.onDestroySuccess());
  }

  private onDestroySuccess(): void {
    this.router.navigate(['..', PROFILE_DESTROY_FINISH_PATH], { relativeTo: this.route, replaceUrl: true });
  }

  private getMemberIdentifier(): Observable<string> {
    return this.getMember().pipe(
      map((member) => {
        if (this.isMsisdnClub() && member?.properties?.msisdn) { return `+${member.properties.msisdn}`; }
        return member?.properties?.email;
      }),
    );
  }

  private getMember(): Observable<Partial<MemberInterface>> {
    return this.memberService.get()
      .pipe(
        filter((member) => !!member),
      );
  }

  private isMsisdnClub(): boolean {
    return this.settingsService.settings.schemaObject.isMsisdnIdentifier();
  }
}
